module.exports = __webpack_public_path__ + "img/red_064.b8b782a9.png";